// GET /api/clients - the client grid. Deliberately no fixture fallback:
// zero clients is a real state (a sheets-only sync creates no Client
// roots), so the page owns honest empty and error screens instead.

import { getAuthHeaders } from "./auth";

export interface ClientListRow {
  _id: string;
  firstName: string;
  lastName: string;
  alienNumber?: string;
  primaryPhone?: string;
  email?: string;
  preferredLanguage?: string;
  status?: string;
  mattersCount: number;
  createdAt?: string;
}

export interface ClientListResult {
  clients: ClientListRow[];
  total: number;
  page: number;
  totalPages: number;
}

// The server's listQuerySchema caps limit at 100.
const CLIENT_PAGE = 100;

export async function fetchClients(search?: string): Promise<ClientListResult> {
  const q = search ? `&search=${encodeURIComponent(search)}` : "";
  const res = await fetch(`/api/clients?limit=${CLIENT_PAGE}&sort=lastName${q}`, {
    headers: { ...getAuthHeaders() },
    credentials: "same-origin",
  });
  if (!res.ok) throw new Error(`GET /api/clients failed: ${res.status}`);
  return (await res.json()) as ClientListResult;
}
